import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { isAuthenticated, isAuthorized } from "@kdose/ng-auth";
import { PrivateKeyFormComponent } from "./private-key-form.component";
import { PrivateKeyListComponent } from "./private-key-list.component";
import { PrivateKeyShowComponent } from "./private-key-show.component";

const privateKeyRoutes: Routes = [
	{
		path: "schluessel/private-schluessel",
		component: PrivateKeyListComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "schluessel/private-schluessel/neu",
		component: PrivateKeyFormComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "schluessel/private-schluessel/:id",
		component: PrivateKeyShowComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
];
@NgModule({
	imports: [RouterModule.forChild(privateKeyRoutes)],
	exports: [RouterModule],
})
export class PrivateKeyRoutingModule {}
